import { createContext, ReactNode, useCallback, useContext, useState } from "react";
import { ActivityItem } from "../../components/CourseActivityCard/ActivityDotNavigation.types";
import { useNavigate } from "../../services";
import { useRouteParamsLo } from "../../utils/useRouteParamsLo";


interface ActivitySelectedContextType {
  activityIdSelected: number | undefined;
  courseIdSelected: number | undefined;
  setActivityIdSelected: (id: number | undefined) => void;
  setCourseIdSelected: (id: number | undefined) => void;
  syncUrlToActivity: (activity: ActivityItem, isStandAlone?: boolean) => void;
}
undefined;
const ActivitySelectedContext = createContext<ActivitySelectedContextType | null>(null);

export const ActivitySelectedProvider = ({
  children,
  syncUrlOnSelection = true
}: {
  children: ReactNode;
  syncUrlOnSelection?: boolean;
}) => {
  const navigate = useNavigate();
  const { rootIdNumber } = useRouteParamsLo();
  
  const [activityIdSelected, setActivityIdSelected] = useState<number | undefined>(undefined);
  const [courseIdSelected, setCourseIdSelected] = useState<number | undefined>(undefined);

  const syncUrlToActivity = useCallback((activity: ActivityItem, isStandAlone?: boolean) => {
    if (!syncUrlOnSelection || !activity?.id || !activity.learningObjectTypology) return;
    function handleDetailLink(){
      if(isStandAlone) {
        return navigate.getDetailLink({
          id: activity.id,
          isForYou: window.location.href.includes("per-te"),
          learningObjectTypology: activity.learningObjectTypology,
          rootId: activity.rootId ?? (Number(rootIdNumber) ?? undefined)
        });
      }
      return navigate.getDetailLink({
        courseId: activity.courseId ?? activity.parentId ?? undefined,
        id: activity.id,
        isForYou: window.location.href.includes("per-te"),
        learningObjectTypology: activity.learningObjectTypology,
        rootId: activity.rootId ?? (Number(rootIdNumber) ?? undefined)
      });
    }
    const detailLink = handleDetailLink();
      
    if (window.location.pathname === detailLink) return;
    navigate(detailLink, { replace: true, state: { preserveScroll: true } });
  }, [navigate, rootIdNumber, syncUrlOnSelection]);

  return (
    <ActivitySelectedContext.Provider 
      value={ {
        activityIdSelected, 
        courseIdSelected,
        setActivityIdSelected, 
        setCourseIdSelected,
        syncUrlToActivity
      } }
    >
      { children }
    </ActivitySelectedContext.Provider>
  );
};

export const useActivityAndCourseSelection = (): ActivitySelectedContextType => {
  const context = useContext(ActivitySelectedContext);
  if (!context) {
    throw new Error("useActivityAndCourseSelection hook must be used within ActivitySelectedProvider");
  }
  return context;
};
